import axios from 'axios';
import {
  FETCH_CALENDAR_EVENTS_FAILURE,
  FETCH_CALENDAR_EVENTS_REQUEST,
  FETCH_CALENDAR_EVENTS_SUCCESS,
} from '../constants/eventsTypes';

const daysOfWeek = Object.freeze([
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]);

const getDateOfWeekDay = (dayOfWeek) => {
  const today = new Date();
  const currentDay = today.getDay();
  const targetDay = daysOfWeek.indexOf(dayOfWeek) + 1;

  const diff = targetDay - currentDay;
  const resultDate = new Date(today);
  resultDate.setDate(today.getDate() + diff);
  return resultDate;
};

const setTimeForDate = (date, time) => {
  const [hours, minutes] = time.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) {
    throw new Error('Invalid time format');
  }
  const resultDate = new Date(date);
  resultDate.setHours(hours, minutes);
  return resultDate;
};

/**
 * Checks if an event has expired based on its endDate.
 * @param {string} endDate - The end date of the event in ISO format (YYYY-MM-DD or ISO string).
 * @returns {boolean} - True if the event has expired, false otherwise.
 */
const isEventExpired = (endDate) => {
  if (!endDate) {
    return false; // Events without an endDate are not expired
  }

  const eventEndDate = new Date(endDate);
  const today = new Date();

  // Set time to start of day for proper date comparison
  eventEndDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return eventEndDate < today;
};

const fetchCalendarEventsRequest = () => {
  return {
    type: FETCH_CALENDAR_EVENTS_REQUEST,
  };
};

const fetchCalendarEventsSuccess = (payload) => {
  return {
    type: FETCH_CALENDAR_EVENTS_SUCCESS,
    payload,
  };
};

const fetchCalendarEventsFailure = (error) => {
  return {
    type: FETCH_CALENDAR_EVENTS_FAILURE,
    payload: error,
  };
};

export const fetchCalendarEvents = () => {
  return (dispatch) => {
    dispatch(fetchCalendarEventsRequest);
    axios
      .get(
        `${process.env.REACT_APP_CMS_URL}/events?populate=icon&pagination[pageSize]=100`
      )
      .then((res) => {
        // Filter out expired events before processing
        const activeEvents = res.data.data.filter(
          (event) => !isEventExpired(event.endDate)
        );

        const fetchedEvents = activeEvents.map((event) => {
          const resultDate = getDateOfWeekDay(event.dayOfWeek);
          const startDate = setTimeForDate(resultDate, event.startTime);
          const endDate = setTimeForDate(resultDate, event.endTime);

          const eventOrder = activeEvents
            .filter((e) => e.dayOfWeek === event.dayOfWeek)
            .sort((a, b) => a.startTime.localeCompare(b.startTime))
            .findIndex((e) => e.id === event.id);

          return {
            title: event.name,
            start: startDate,
            end: endDate,
            ticketType: event.ticketType,
            resource: {
              url: event.url,
              color: event.color,
              icon: event.icon?.data,
              order: eventOrder,
            },
          };
        });

        dispatch(fetchCalendarEventsSuccess(fetchedEvents));
      })
      .catch((err) => {
        dispatch(fetchCalendarEventsFailure(err.message));
      });
  };
};
